import Map from 'components/DriverMap/Map/container';

export default Map;
